import { Buffer } from 'buffer'
;(globalThis as unknown as { Buffer: typeof Buffer }).Buffer = Buffer

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.css'
import { Capacitor } from '@capacitor/core'
import { setProxyBaseUrl } from '@properwallet/chain-eos'

// Native app: our proxies (/ipfs-proxy, /paycash-*-proxy, /api/push-*) live on
// the Vercel deployment, not on the WebView's https://localhost origin.
// See packages/chain-eos/src/proxy-base.ts and apps/mobile/api/_cors.ts.
if (Capacitor.isNativePlatform()) {
  setProxyBaseUrl('https://properwallet-mobile.vercel.app')
}

// pako/zlib must be on window before any WharfKit import
import * as pako from 'pako'
;(window as unknown as Record<string, unknown>).zlib = pako

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
